import IncubatorManage from './index';
import Activity from './activity';
import Air from './air';


export default {
    path: '/home/incubator',
    component: IncubatorManage,
    children: [
        {path: '/home/incubator/activity', component: Activity},
        {path: '/home/incubator/air', component: Air}
    ]
};